export const DEFAULT_TABLE_PAGE_SIZE = 10;
export const PAGINATION_OPTIONS = [10, 50, 100, 200];
